import { CheckCircle2, FileText, Loader2, X, XCircle } from 'lucide-react';

import { Button } from '@/components/ui/button';
import { Progress } from '@/components/ui/progress';

import type { UploadQueueItem } from '../../types';

interface Props {
  queue: UploadQueueItem[];
  onDismiss: (id: string) => void;
}

/** Fila de upload flutuante (estilo Drive) — aparece sozinha ao iniciar upload. */
export function UploadQueuePanel({ queue, onDismiss }: Props) {
  if (queue.length === 0) return null;

  return (
    <div className="bg-card fixed right-4 bottom-4 z-50 w-80 max-w-[calc(100vw-2rem)] rounded-lg border shadow-lg">
      <div className="border-b px-4 py-2.5">
        <p className="text-sm font-semibold">Enviando {queue.length} arquivo(s)</p>
      </div>
      <ul className="max-h-72 space-y-1 overflow-y-auto p-2">
        {queue.map((item) => (
          <li key={item.id} className="flex items-center gap-3 rounded-md px-2 py-2">
            <FileText className="text-muted-foreground size-4 shrink-0" />
            <div className="min-w-0 flex-1 space-y-1">
              <p className="truncate text-xs font-medium">{item.file.name}</p>
              {item.status === 'uploading' && <Progress value={item.progress} className="h-1" />}
              {item.status === 'error' && <p className="text-destructive text-xs">{item.error}</p>}
            </div>
            {item.status === 'uploading' && <Loader2 className="size-4 shrink-0 animate-spin" />}
            {item.status === 'done' && <CheckCircle2 className="size-4 shrink-0 text-green-500" />}
            {(item.status === 'error' || item.status === 'pending') && (
              <Button
                size="icon"
                variant="ghost"
                className="size-6"
                onClick={() => onDismiss(item.id)}
                aria-label={`Remover "${item.file.name}" da fila`}
              >
                {item.status === 'error' ? (
                  <XCircle className="text-destructive size-4" />
                ) : (
                  <X className="size-4" />
                )}
              </Button>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
}
